enum Status {
  Saved = 0,
  Submitted = 21,
  ApprovedbyAdmin = 95,
  RejectedbyAdmin = 96
}

enum CompletionStatus {
  Saved = 0,
  Submitted = 20,
  Completed = 90
}

enum ActionType {
  Submitted = 20,
  ApprovedbyAdmin = 95,
  RejectedbyAdmin = 96
}

export const completionApliicationEnum = { Status, CompletionStatus, ActionType }
